{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Смотреть все варианты",
  "Spoiler_Reveal_Tooltip": "Кликните, чтобы раскрыть",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Твитнуть",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Товар в свернутом списке",
  "Spoiler_Reveal_Video_CTA": "Показать",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Раскрыть фото",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Смотреть все результаты",
  "Spoiler_Reveal_Image_Placeholder": "Изображение содержит спойлер",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Найти слайдер",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Вы можете проголосовать за несколько вариантов.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Показать больше элементов управления аудио",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Закрыть",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "Загрузка {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Аватар пользователя",
  "Preview_ReadMore_Label": "Подробнее",
  "Spoiler_Insert_Tooltip": "Спойлер",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Громкость",
  "Spoiler_Reveal_Gallery_Placeholder": "В галерее есть спойлер",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Забронировать",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Включить",
  "Spoiler_Reveal_Gallery_CTA": "Показать",
  "Poll_Viewer_ShowLess_CTA": "Свернуть",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Отключить",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} анонимно",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Следить",
  "VerticalEmbed_Products_Button": "Купить",
  "Poll_Viewer_Toast_Error_ServerDown": "Не удалось подключиться к серверу. Попробуйте позже.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "За этот ответ проголосовали {{count}} чел.",
  "Poll_Viewer_VoteCount": "Голосов: {{number}}",
  "VerticalEmbed_Events_Button": "Зарегистрироваться",
  "Spoiler_Reveal_Image_CTA": "Показать",
  "Poll_Viewer_Toast_Error_Connection": "Нет сети. Проверьте соединение.",
  "Poll_Viewer_Visibility_Owner_Footer": "Только вы видите результаты.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "За этот ответ проголосовали {{count}} чел.",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Товар в развернутом списке",
  "Audio_Plugin_Cover_Alt": "Обложка аудио",
  "Spoiler_Reveal_Video_Placeholder": "Видео содержит спойлер",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Показать весь пост",
  "UploadFile_Viewer_Download": "Скачать {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} ч.",
  "VerticalEmbed_Units_Minute": "{{minutes}} мин.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
